/*
 * @Author: 朱占为
 * @LastEditors: 邱扬
 * @description: 应用状态管理
 * @Date: 2021-07-20 10:23:19
 * @LastEditTime: 2021-10-15 09:59:02
 */

import getters from "./getter"
import { createStore } from 'vuex';
import dashboard from './dashboard'
import user from './user'
import order from './order'

//应用状态
const state = () => {
  return {
    payTypes: null , //支付方式
    payInfo: null , //支付说明信息
    mineInfo:null
  };
};

// 操作管理
const mutations = {
  //保存支付方式
  SET_PAYRTPES(state, data = null) {
    state.payTypes = data;
  },
  //保存支付方式
  SET_PAYINFO(state, data = null) {
    state.payInfo = data;
  }
};

// 可异步操作
const actions = {
  savePayTypes({ commit }, data = null) {
    commit('SET_PAYRTPES', data);
  },
  savePayInfo({ commit }, data = null) {
    commit('SET_PAYINFO', data);
  },
};


export const store = createStore({
  state,mutations,actions,
  modules:{
    dashboard,
    user,
    order
  },
  getters
});

export default function(app) {

  app.use(store);
}
